module.exports = __webpack_public_path__ + "media/images/soar/user_experience_eduarda-838cd743879e25ea3884f00525726cbb.png";